import React, { useEffect, useMemo, useState } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useOrganizationDeleteDataUIContext } from "../OrganizationDeleteDataUIContext";
import { initialFilter } from "../OrganizationDeleteDataUIHelpers";
import AsyncSelect from "react-select/async";
import { genOptionLoaderParams } from "../../../../../../_metronic/_helpers/fetchUtils";
import { findorganization } from "../../../_redux/organization/organizationCrud";

export const OrganizationDeleteDataFilter = ({ onOpenModal, onSetOrganization }) => {
  const [currentTimeout, setCurrentTimeout] = useState(null);

  return (
    <Formik
      initialValues={initialFilter.filter}
      enableReinitialize
      onSubmit={values => {
        onSetOrganization(values);
        if (values.name && values.uuid) {
          onOpenModal(true);
        }
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
              <div className="col-lg-5">
                <label htmlFor="organization_regional">Pilih Lembaga</label>
                <AsyncSelect
                name="organization_uuid"
                loadOptions={genOptionLoaderParams(
                  inputValue =>
                    findorganization({
                      page1umber: 1,
                      pageSize: 50,
                      filter: { name: inputValue }
                    }),
                  ({ name, uuid }) => ({
                    label: name ?? "",
                    value: uuid ?? ""
                  }),
                  currentTimeout,
                  setCurrentTimeout
                )}
                isClearable
                onChange={e => {
                  const value = e && e.value;
                  if (value) {
                    setFieldValue("name", e.label);
                    setFieldValue("uuid", value);
                  } else {
                    setFieldValue("uuid", "");
                  }
                }}
              />
              </div>
              <div className="col-lg-7 mt-5 mt-lg-0" style={{display: 'flex', alignSelf: 'self-end'}}>
              <button
                className="btn btn-danger float-right"
                onClick={handleSubmit}
              >
                Reset Data Lembaga
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
